<template>
  <div>
    <div class="grid">
      <div class="grid-title">
        <div class="row">
          <div class="col-md-6">
            <h4>Always Overridden</h4>
          </div>
          <div class="col-md-6 text-right">
            <button
              class="btn btn-primary"
              @click="showCreateAvailableFabricDialog"
            >
              <i class="fa fa-plus-circle" aria-hidden="true"></i> Add Override
            </button>
          </div>
        </div>
      </div>
      <div class="grid-body">
        <vue-good-table
          mode="remote"
          :totalRows="totalRecords"
          styleClass="table table-bordered"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
          }"
          :columns="columns"
          :rows="rows"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'action'">
              <a
                class="btn btn-sm btn-danger"
                @click="deleteAvailableFabric(props.row)"
              >
                Delete Override
              </a>
            </span>
            <span v-else-if="props.column.field == 'reserved_stock'">
              {{ props.formattedRow[props.column.field] ? props.formattedRow[props.column.field].toFixed(2) : 0 }} m
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>

    <div
      class="modal fade"
      id="modal-box"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modelTitleId"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-bold">New Available Fabric</h5>
          </div>
          <div class="modal-body bg-white">
            <div class="form-group">
              <label>Fabric ID </label>
              <v-select
                class="select-fabric"
                :options="fabrics"
                :reduce="(fabric) => fabric.id"
                label="production_name"
                v-model="formData.fabric_id"
                placeholder="Select Fabric"
              />
              <small v-if="errors.message" class="form-text text-danger">
                {{ errors.message }}
              </small>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="createAvailableFabric()"
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TableHelper } from "@/pages/Tools/TableHelper.js";
import { VueGoodTable } from "vue-good-table";
export default {
  name: "AlwaysAvailableFabrics",
  components: {
    VueGoodTable,
  },
  data() {
    return {
      totalRecords: 0,
      rows: [],
      fabrics: [],
      formData: {},
      errors: {},
      columns: [
        {
          label: "Fabric ID",
          field: "fabric_id",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Fabric Name",
          field: "fabric_name",
          tdClass: "text-left",
          thClass: "text-left",
        },
        {
          label: "Reserved Stock",
          field: "reserved_stock",
          tdClass: "text-center",
          thClass: "text-center",
        },
        {
          label: "",
          field: "action",
          tdClass: "text-right",
          thClass: "text-right",
          sortable: false,
        },
      ],
    };
  },
  mounted() {
    this.tableHelper = new TableHelper({
      parent: this,
      endpoint: "/v2/fabrics/availability_override/always",
      sort: {
        fabric_id: "asc",
      },
    });
    this.getFabrics();
  },
  methods: {
    async getFabrics() {
      let res = await axios.get("/v2/fabrics?as_dropdown=1");
      this.fabrics = res.data.data.collection;
    },
    showCreateAvailableFabricDialog() {
      this.errors = {};
      this.formData = {};
      show_modal("#modal-box");
    },
    async createAvailableFabric() {
      try {
        let response = await axios.post(
          "v2/fabrics/availability_override/always",
          {
            fabric_id: this.formData.fabric_id,
          }
        );

        /**
         * The existing API will still send a HTTP 200 status when an error occurs.
         * That why we need to check the value of the boolean `status` in the JSON response
         * to catch any potential error.
         */
        if (response.data.status) {
          this.tableHelper.reloadData();
          toastr.success("Success");
          hide_modal("#modal-box");
        } else {
          this.errors = response.data;
          toastr.error(response.data.message);
        }
      } catch (error) {
        this.errors = error.response.data;
        toastr.error(error.response.data.message);
      }
    },
    async deleteAvailableFabric(override) {
      let result = await Swal.fire({
        title: "Are you sure to Delete?",
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "NO",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "DELETE",
      });

      if (!result.value) {
        return;
      }
      try {
        let response = await axios.delete(
          `v2/fabrics/availability_override/always/${override.id}`
        );
        /**
         * The existing API will still send a HTTP 200 status when an error occurs.
         * That why we need to check the value of the boolean `status` in the JSON response
         * to catch any potential error.
         */
        if (response.data.status) {
          this.tableHelper.reloadData();
          toastr.success("SUCCESS");
        } else {
          this.errors = response.data;
          toastr.error(response.data.message);
        }
      } catch (error) {
        toastr.error(
          "Unable to delete this available fabric, contact the admins for help!"
        );
      }
    },
  },
};
</script>

<style scoped>
</style>
